// import external dependencies
import "promise-polyfill/dist/polyfill.min";
import 'jquery';
import "./autoload/_bootstrap.js"; import "./autoload/_fancybox.js"; import "./autoload/_fortawesome.js";

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateHome from './routes/templateHome';
import aboutUs from './routes/about';
import serviceFinder from './routes/serviceFinder';
import resources from './routes/resources';
import templateEventsOverview from './routes/events';
import templateSimpleResourcePage from "./routes/nonCptResources";

/** Populate Router instance with DOM routes */
const routes = new Router({
    common,
    templateHome,
    aboutUs,
    serviceFinder,
    resources,
    templateSimpleResourcePage,
    templateEventsOverview,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js